import { Component, OnInit, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from '@angular/forms';
import { AppService } from "../app.service";
import { Case } from "../app.entities";
import { Headers, Http, RequestOptions } from '@angular/http';
import * as $ from "jquery";

@Component({
    selector: "case-details",
    templateUrl: "./casedetails.component.html",
    styleUrls: ["./casedetails.component.css"]
    //styles: ["th { text-align: left; } .case-message { width: 100%; position: relative; } .case-table { border-collapse: collapse; padding-left: 1rem; padding-right: 1rem; position: relative; width: 100%; } .case-table td, .case-table th { padding: 1rem; } .case-table th { font-weight: bold; } .case-table__row { background-color: #fff; } .case-table__row:nth-child(odd) {background: #f4f4f4; }"]
})

export class CaseDetailsComponent implements OnInit {

    key: string;
    model: Case | null;
    uploadingFile = false;
    postingMessage = false;
    caseMessage: string;
    comment: string;
    errorMessage: string;
    showError = false;
    tempFile: string;
    uploadedFile: any;
    uploadFiles = [] as any;
    inputFilesContentPresent: boolean = false;
    showUploadAttachments: boolean = false;
    showPostComment: boolean = false;
    oldCase: boolean = false;
    caseDate: Date;
    today: Date = new Date();
   
    constructor(
        private caseLookupService: AppService,
        private router: Router,
        private route: ActivatedRoute) { }

    get isLoading(): boolean {
        return this.model === undefined
            || this.model === null
            || this.uploadingFile
            || this.postingMessage;
    }

    ngOnInit(): void {       
        this.route.queryParams.subscribe(queryParams => {
            const key = queryParams["key"];
            if (typeof (key) !== "undefined") {
                this.key = key;
                this.loadCase(); 
            }
            else {
                this.router.navigate([`/support/case-lookup`]);
            }
        });
    }
     
    loadCase() {
        this.caseLookupService
            .getCaseDetails(this.key)
            .subscribe(
                response => 
                {
                    this.model = response;
                    this.caseDate = new Date(this.model.createdDate);
                    var diff = (<any>this.today.getTime() - <any>this.caseDate.getTime());
                    var days = Math.round(
                        diff / (1000 * 3600 * 24)
                      )
                    console.log("diff:" + days );
                    if(days > 180)
                      {
                        this.oldCase = true;
                        this.showPostComment = false;
                        this.showUploadAttachments = false;
                      }
                },
                error => this.handleError(error)
            );            
    }

    onSubmitMessage() {
        this.postingMessage = true;
        window.scrollTo(0, 0);
        this.caseLookupService.addMessageToCase(this.key, this.caseMessage)
            .subscribe(
                response => this.model = response,
                error => this.handleError(error),
            () => { this.postingMessage = false, this.caseMessage='' }
            );        
    }  

    onSubmitFile(): void {       
            this.uploadingFile = true;
            window.scrollTo(0, 0);            
            this.caseLookupService.addDocumentToCase(this.key, this.comment, this.uploadFiles)
                .subscribe(
                    response => this.loadCase(),
                    error => this.handleError(error),
                    () => { this.uploadingFile = false, this.uploadFiles = null, this.comment = '' }
                );       
    }

    handleError(error: any): void {  
        this.uploadingFile = false;
        this.postingMessage = false;
        this.showError = true; 
        if (!this.model) {
             this.model = {} as any;
       }          
        if (typeof (error.error.exceptionMessage) != 'undefined' && error.error.exceptionMessage.indexOf("No Case was found") > -1) {
            this.errorMessage = "No Case was found for the Case Number and Email address provided";
        }       
        else {
            console.log(error.error.exceptionMessage);
            this.errorMessage = " Oops, something went wrong� We have sent an email to the team.";
        }        
    }

    fileChange(event): void {
        const fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            this.uploadedFile = fileList[0];
            this.tempFile = this.uploadedFile.name;
            this.uploadFiles = [];
            for (var i = 0; i < event.target.files.length; i++) {
                this.uploadFiles.push(event.target.files[i]);
            } 
            this.inputFilesContentPresent = true;
            if (event.target.accept) {
                let fileAssocArray = event.target.accept.split(',');
                for (var i = 0; i < event.target.files.length; i++) {
                    let fileName = event.target.files[i].name;
                    let fileExt = (fileName.split(/[. ]+/).pop()).toLowerCase();
                    if (fileAssocArray.indexOf(`.${fileExt}`) == -1) {                                            
                        this.tempFile = '';
                        this.uploadFiles = [];
                        this.inputFilesContentPresent = false;
                        alert(`.${fileExt} files are not allowed. Please choose one of the following file types: (${fileAssocArray})`);
                    }
                }
            }            
        }
    }
    // remove clicked image file
    removeImage(event): void {
        event.preventDefault();
        var fileName = event.target.parentElement.firstElementChild.innerText;
        for (let i = 0; i < this.uploadFiles.length; ++i) {
            if (this.uploadFiles[i].name == fileName) {
                this.uploadFiles.splice(i, 1);
            }
        }
        $(this).parent().remove();
        if (this.uploadFiles.length > 0) {
            this.inputFilesContentPresent = true;
        }
        else {
            // needed for fileinput validation
            this.tempFile = "";
        }
    }

    togglePostComment() {
        this.showPostComment = !this.showPostComment;
    }

    toggleUploadAttachments() {
        this.showUploadAttachments = !this.showUploadAttachments;
    }

    onCancelMessage() {
        this.caseMessage = '';
        this.showPostComment = false;
    }

    onCancelUpload() {
        this.comment = '';
        this.uploadFiles = null
        this.showUploadAttachments = false;
    }
}


// WEBPACK FOOTER //
// ./src/ts/Apps/CaseLookup/src/app/case-details/casedetails.component.ts